import React from 'react';
import {Rnd} from 'react-rnd';
import 'styles/pictures/share/ResizableDraggable.css';

const ResizableDraggable = ({children, enabled, flagName, defaultPosition, dragStart, minWidth}) => {
    return (
        <Rnd
            minWidth={minWidth}
            bounds="parent"
            default={defaultPosition} // Use the provided defaults
            style={{
                border: `2px dashed ${enabled ? 'rgba(128, 128, 128, 0.6)' : 'transparent'}`,
                boxSizing: 'border-box',
                position: 'absolute',
            }}
            dragHandleClassName="drag-handle"
            lockAspectRatio={true}
            enableResizing={enabled}
            disableDragging={false}
            onDragStart={() => {
                dragStart(flagName);
            }}
        >
            <div
                id={'placeholder-for-id-' + flagName}
                style={{
                    width: '100%',
                    height: '100%',
                    position: 'relative',
                    cursor: enabled ? 'move' : 'default',
                }}
                className={`parent-div-draggable drag-handle`}
                onDragStart={(e) => e.preventDefault()} // Prevent native drag behavior
            >
                {children}
                <div className={`resizable-draggable-point top-left ${enabled ? 'enabled' : ''}`}/>
                <div className={`resizable-draggable-point top-right ${enabled ? 'enabled' : ''}`}/>
                <div className={`resizable-draggable-point bottom-left ${enabled ? 'enabled' : ''}`}/>
                <div className={`resizable-draggable-point bottom-right ${enabled ? 'enabled' : ''}`}/>
            </div>
        </Rnd>
    );
};

export default ResizableDraggable;